// frontend/src/pages/supplierCatalogLinks.js
//
// Where a Supplier catalog drill-through goes. One home for the URL shape,
// because two screens build it: Supplier setup's catalog column (the whole
// catalog) and the links that open it on one item (Data Health's
// contradictory_order_constraints fix, the item Suppliers dialog's "Edit
// terms").
//
// The item rides a route SEGMENT, not a query param: tabs are keyed by
// pathname (TabsHost matchPaths the whole tab.path), so `?item_code=` would
// resolve to no registered route. `/suppliers/:id/catalog/:itemCode?` is the
// registered shape (tabs/routeRegistry.jsx); SupplierCatalog reads the segment
// back through decodeRouteSegment and filters to that one item.

/**
 * @param {number|string} supplierId
 * @param {string} [itemCode]  The item_code of the one item to filter the
 *   catalog to. Encoded, so a code carrying '/', '&' or spaces still arrives
 *   as ONE segment — pinned against the real route registry in
 *   supplierCatalogLinks.test.js.
 * @returns {string} Tab path for openTab().
 */
export const supplierCatalogPath = (supplierId, itemCode = '') => (
  itemCode
    ? `/suppliers/${supplierId}/catalog/${encodeURIComponent(itemCode)}`
    : `/suppliers/${supplierId}/catalog`
);
